export const validateEmail = (value: string) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
}

export const validatePhoneNumber = (value: string) => {
  return /((\(\d{3}\) ?)|((\d{3}-))?\d{3}-\d{4})|^[0-9]{10}$/i.test(value)
}
